import * as React from 'react';
import { noop } from '../../util/fn-util';
import './Field.scss';

/**
 * Field is the wrapper component for label and input that will inject field statuses
 * to label and input so the styling can be applied accordingly
 */
export class Field extends React.Component<IParentProps, IFieldContext> {
  render() {
    return (
      <FieldContext.Provider value={this.state}>
        <div className="field">{this.props.children}</div>
      </FieldContext.Provider>
    );
  }

  handleSetIsFilled = (isFilled: boolean) => () =>
    this.setState({
      isFilled
    });

  handleSetIsFocused = (isFocused: boolean) => () => this.setState({ isFocused });

  state = {
    handleSetIsFilled: this.handleSetIsFilled,
    handleSetIsFocused: this.handleSetIsFocused,
    isFilled: false,
    isFocused: false,
    fieldId: this.props.fieldId
  };
}

const DEFAULT_CONTEXT: IFieldContext = {
  isFilled: false,
  isFocused: false,
  fieldId: undefined,
  handleSetIsFilled: () => noop,
  handleSetIsFocused: () => noop
};

const FieldContext = React.createContext(DEFAULT_CONTEXT);

export const FieldContextConsumer = FieldContext.Consumer;

interface IParentProps {
  fieldId?: string;
}

export interface IFieldContext {
  /** is the input filled with any value */
  isFilled: boolean;
  /** is the input being focused */
  isFocused: boolean;
  /** id of the field */
  fieldId: string | undefined;
  /**
   * @param isFilled the value of isFilled when callback is invoked
   */
  handleSetIsFilled: (isFilled: boolean) => () => void;
  /**
   * @param isFocused the value of isFocused when callback is invoked
   */
  handleSetIsFocused: (isFocused: boolean) => () => void;
}



// WEBPACK FOOTER //
// ./src/components/Control/Field.tsx